module.exports = __webpack_public_path__ + "img/electric_reserved.625611f0.svg";